import React, { useContext, useEffect, useState } from 'react'

import BtnPrimary from '../../components/Buttons/Primary'
import FormGroup from '../../components/Forms/Group'
import InputText from '../../components/Fields/InputText'
import Window from '../../components/Divs/Window'

import loginUser from '../actions/loginUser'

import { Session } from "../provider";

const Component = (props) => {

	const initFieldState = {
		email: "",
		password: ""
	}

  const { state, dispatch } = useContext(Session);
  const [ fields, setFields ] = useState(initFieldState)
  const [ effect, causeEffect ] = useState(false)
  const [ isFormSubmitEnabled, setFormSubmitEnabled ] = useState(false)
  
  useEffect(() => {
    const _isFormSubmitEnabled = fields.email.length > 0 && fields.password.length > 0
    setFormSubmitEnabled(_isFormSubmitEnabled)
  }, [effect])

  const handleCallback = () => {
  	if(!props.location.search) return false
  	return props.location.search.replace("?", "")
  }

  const handleField = (selected) => (event) => {
    const new_fields = fields
    new_fields[selected] = event.target.value
    setFields(new_fields)
    causeEffect(!effect)
  }

  const handleLogin = () => {
    const email = fields.email
    const password = fields.password
    const credentials = { email, password }
    const redirect = handleCallback()
    !state.logging && loginUser(credentials, redirect)(dispatch);
  }

  const handleKeyPress = () => (event) => {
		event.key === 'Enter' && isFormSubmitEnabled && handleLogin()
  }

  const btnPrimaryProps = {
  	className: isFormSubmitEnabled ? "pri" : "sec",
    disabled: !isFormSubmitEnabled,
  	onClick: handleLogin,
  	title: "ENTRAR"
  }

  const initFormState = {
  	message: state.message,
  	submited: state.submited,
  	success: state.success,
  }
  
  const inputEmailProps = {
  	className: "pri",
    defaultValue: "",
  	label: "Digite seu e-mail",
    onChange: handleField("email"),
    onKeyPress: handleKeyPress(),
  	type: "text"
  }
  
  const inputPasswordProps = {
  	className: "pri",
  	label: "Digite sua senha",
    onChange: handleField("password"),
    onKeyPress: handleKeyPress(),
  	type: "password",
  }

	return (
		<Window>
			<FormGroup {...initFormState}>
				<InputText {...inputEmailProps} />
				<InputText {...inputPasswordProps} />
	  		<BtnPrimary {...btnPrimaryProps} />
			</FormGroup>
		</Window>
	)
}

export default Component
